package app.nestbridge.feature.careteam.api.model

import app.nestbridge.domain.identity.api.model.ProfessionalServiceTypeDto
import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class CareTeamDto(
    val id: String,
    val childId: String,
    val teamType: ProfessionalServiceTypeDto,
    val description: String? = null,
    val members: List<CareTeamMemberDto> = emptyList(),
    val status: String,
    val createdAt: Instant,
    val createdBy: String,
    val modifiedAt: Instant,
    val modifiedBy: String,
)
